import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../../common/CancelButton";
import Swal from "sweetalert2";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import html2pdf from "html2pdf.js";
import ConfirmButton from "../../../common/ConfirmButton";
import DeleteButton from "../../../common/DeleteButton";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteProduct,
  getOrder,
  updateOrder,
  updateOrderStatus,
} from "../../../../services/order.service";
import ShippedButton from "../../../common/ShippedButton";
import DeliveredButton from "../../../common/DeliveredButton";
import { getAllDesignRates } from "../../../../services/ratediary.service";

export default function DetailsPage() {
  const { token } = useSelector((state) => state?.auth);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderId = params.get("id");
  const tabName = params.get("tab");
  const [products, setProducts] = useState(null);
  const [status, setStatus] = useState();
  const [totalQuantity, setTotalQuantity] = useState(0);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("details");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    navigate(`?id=${orderId}&tab=${tabName}`);
  };

  useEffect(() => {
    setActiveTab(tabName || "details");
  }, [tabName]);

  const [order, setOrder] = useState(null);

  const renderButtons = () => {
    switch (status) {
      case "PENDING":
        return (
          <>
            <ConfirmButton
              orderId={orderId}
              onConfirm={(id) => handleStatusChange("CONFIRMED")}
            />
            <CancelButton
              orderId={orderId}
              onCancel={(id) => handleStatusChange("CANCELLED")}
            />
          </>
        );

      case "CONFIRMED":
        return (
          <>
            <ShippedButton
              orderId={orderId}
              onShipped={(id) => handleStatusChange("SHIPPED")}
            />
            <CancelButton
              orderId={orderId}
              onCancel={(id) => handleStatusChange("CANCELLED")}
            />
          </>
        );

      case "SHIPPED":
        return (
          <>
            <DeliveredButton
              orderId={orderId}
              onDelivered={(id) => handleStatusChange("DELIVERED")}
            />
            <CancelButton
              orderId={orderId}
              onCancel={(id) => handleStatusChange("CANCELLED")}
            />
          </>
        );

      default:
        return <p className="text-muted mb-3 mt-5">ORDER {status}</p>;
    }
  };

  const fetchOrder = async () => {
    try {
      const res = await getOrder(token, orderId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res?.data);

        setOrder(res?.data);
        setProducts(res?.data?.placed_orders);
        setTotalQuantity(
          res?.data?.placed_orders.reduce(
            (sum, product) => sum + product.quantity,
            0
          )
        );
        setStatus(res?.data?.status);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch order details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the order?. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  // const handleAddProduct = async (barcodeData) => {
  //   if (status !== "PENDING") {
  //     return;
  //   }

  //   if (!barcodeData) {
  //     alert("Please scan a barcode!");
  //     return;
  //   }

  //   console.log("Scanning barcode:", barcodeData);

  //   try {
  //     // Fetch design rates
  //     const designParams = { design_id: barcodeData };
  //     const designRes = await getAllDesignRates(token, designParams);

  //     if (!designRes || designRes.status < 200 || designRes.status >= 300) {
  //       const errorMessage =
  //         designRes?.data?.message ||
  //         "Failed to fetch design ID. Please try again.";
  //       console.error("Error fetching design rates:", errorMessage);
  //       alert(errorMessage);
  //       return;
  //     }

  //     console.log("Fetched design rates:", designRes.data);

  //     if (!designRes.data) {
  //       alert("No design rates found for the scanned barcode.");
  //       return;
  //     }

  //     // Add product to order
  //     const orderParams = { new_product_id: barcodeData };
  //     const orderRes = await updateOrder(token, orderId, orderParams);

  //     if (orderRes && orderRes.status >= 200 && orderRes.status < 300) {
  //       console.log("Added to order:", orderRes.data);
  //       fetchOrder(); // Refresh order details
  //     } else {
  //       const orderErrorMessage =
  //         orderRes?.data?.message ||
  //         "Failed to add item to order. Please try again.";
  //       console.error("Error adding product to order:", orderErrorMessage);
  //       alert(orderErrorMessage);
  //     }
  //   } catch (error) {
  //     console.error("Unexpected error occurred:", error);
  //     alert("An unexpected error occurred. Please try again later.");
  //   } finally {
  //     setValue("designID", ""); // Clear the input field
  //   }
  // };

  // Barcode Scanner Code
  // useEffect(() => {
  //   let barcodeBuffer = "";
  //   let debounceTimeout;

  //   const handleKeyDown = (evt) => {
  //     if (debounceTimeout) clearTimeout(debounceTimeout);

  //     if (evt.code === "Enter") {
  //       if (barcodeBuffer) {
  //         handleBarcode(barcodeBuffer);
  //         barcodeBuffer = "";
  //       }
  //       return;
  //     }

  //     if (evt.key !== "Shift") {
  //       barcodeBuffer += evt.key;
  //     }

  //     debounceTimeout = setTimeout(() => {
  //       barcodeBuffer = "";
  //     }, 50);
  //   };

  //   const handleBarcode = (scannedBarcode) => {
  //     handleAddProduct(scannedBarcode); // Pass the scanned barcode to the handler
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     if (debounceTimeout) clearTimeout(debounceTimeout);
  //   };
  // }, [handleAddProduct]);

  const handleEnterAddProduct = async (item) => {
    console.log("item:", item);

    if (status !== "PENDING") {
      return;
    }

    try {
      // Fetch design rates
      const designParams = { design_id: item };
      const designRes = await getAllDesignRates(token, designParams);

      if (!designRes || designRes.status < 200 || designRes.status >= 300) {
        const errorMessage =
          designRes?.data?.message ||
          designRes?.data?.error ||
          "Failed to fetch design ID. Please try again.";
        console.error("Error fetching design rates:", errorMessage);
        alert(errorMessage);
        return;
      }

      console.log("Fetched design rates:", designRes.data);

      if (!designRes.data) {
        alert("No design rates found for the scanned barcode.");
        return;
      }

      // Add product to order
      const orderParams = { new_product_id: item };
      // console.log(orderParams);

      const orderRes = await updateOrder(token, orderId, orderParams);
      // console.log(orderRes);

      if (orderRes && orderRes.status >= 200 && orderRes.status < 300) {
        console.log("Added to order:", orderRes);
        fetchOrder(); // Refresh order details
      } else {
        const orderErrorMessage =
          orderRes?.data?.message ||
          orderRes?.data?.error ||
          "Failed to add item to order. Please try again.";
        console.error("Error adding product to order:", orderErrorMessage);
        alert(orderErrorMessage);
      }
    } catch (error) {
      console.error("Unexpected error occurred:", error);
      alert("An unexpected error occurred. Please try again later.");
    } finally {
      setValue("designID", ""); // Clear the input field
    }
  };

  const {
    register,
    handleSubmit: handleSbmit,
    formState: { errors },
    setError,
    clearErrors,
    setValue,
    reset,
  } = useForm();

  const orderFormRef = useRef(null);

  const handlePrint = () => {
    const element = document.getElementById("orderFormToPrint");
    element.classList.remove("d-none"); // Ensure the element is visible

    const opt = {
      margin: 0,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: "#ffffff" }, // White background for better printing
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const blobUrl = URL.createObjectURL(pdf.output("blob"));
        const printWindow = window.open(blobUrl, "_blank");

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.onafterprint = () => {
              printWindow.close();
            };
          };
        }
      });
  };

  const downloadOrderForm = () => {
    const element = document.getElementById("orderFormToPrint");
    element.classList.remove("d-none");

    const opt = {
      margin: 0,
      filename: `OrderForm.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: "#f0f9e7" },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .finally(() => {
        // Hide the element again after generating the PDF
        // element.classList.add("d-none");
      });
  };

  const downloadPDF = () => {
    const element = document.getElementById("htmlToPrint");
    element.classList.remove("d-none");

    const opt = {
      margin: 0,
      filename: `TAX-INVOICE-${orderId}`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: "#f0f9e7" },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .finally(() => {
        // Hide the element again after generating the PDF
        element.classList.add("d-none");
      });
  };

  const downloadchallanPDF = () => {
    const element = document.getElementById("challanToPrint");
    element.classList.remove("d-none");

    const opt = {
      margin: 0,
      filename: `ESTIMATED_INVOICE-${orderId}`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: "#f0f9e7" },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .finally(() => {
        // Hide the element again after generating the PDF
        element.classList.add("d-none");
      });
  };

  const [isLoading2, setIsLoading2] = useState(false);

  const handleStatusChange = async (newStatus) => {
    setIsLoading2(true);

    const data = {
      status: newStatus,
    };

    try {
      const res = await updateOrderStatus(token, data, orderId);

      // console.log(res.data);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: `${newStatus}!`,
          text: `Order #${orderId} has been ${newStatus} successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          fetchOrder();
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.error || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error ||
            "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating order:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
      setStatus(newStatus);
    }
  };

  const buttonClass =
    status === "SHIPPED"
      ? "btn-secondary"
      : status === "CANCELLED"
      ? "btn-danger"
      : status === "PENDING"
      ? "btn-warning"
      : status === "DELIVERED"
      ? "btn-success"
      : "btn-info";

  // Handle product deletion
  const handleDelete = async (itemId) => {
    console.log(itemId);

    try {
      if (products?.length <= 1) {
        Swal.fire({
          title: "Warning!",
          text: `You can not Delete all Products`,
          icon: "warning",
        }).then(() => {
          fetchOrder();
        });
      } else {
        const res = await deleteProduct(token, itemId);

        // console.log(res);

        if (res && res.status >= 200 && res.status < 300) {
          Swal.fire({
            title: "Deleted!",
            text: `Product has been deleted successfully.`,
            icon: "success",
          }).then(() => {
            fetchOrder();
          });
        } else {
          Swal.fire(
            "Error",
            res?.data?.detail ||
              "Failed to delete the Product. Please try again.",
            "error"
          );
        }
      }
    } catch (error) {
      console.error("Error during product deletion:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const onSubmitData = (item) => {
    console.log(item);
  };

  const handleModifyAllQuantities = () => {
    const updatedProducts = products.map((product) => ({
      ...product,
      quantity: "",
      price: 0,
    }));

    setProducts(updatedProducts);
  };

  const handleUpdateQuantity = async (item, newQuantity) => {
    // console.log(item, newQuantity);

    const updatedProducts = products.map((product) =>
      product.design_id === item.design_id
        ? { ...product, quantity: "", price: 0 }
        : product
    );

    setProducts(updatedProducts);

    if (item) {
      try {
        const orderParams = { cart_item_id: item.id, quantity: newQuantity };

        const res = await updateOrder(token, orderId, orderParams);

        if (res && res.status >= 200 && res.status < 300) {
          const hasBlankQuantities = products.some(
            (item) =>
              item.quantity === null ||
              item.quantity <= 0 ||
              item.quantity === ""
          );

          if (!hasBlankQuantities) {
            fetchOrder();
          }
          console.log("Order item updated:", res.data);
        } else {
          console.log("Failed to update order item");
        }
      } catch (error) {
        console.log("Error updating order item:", error);
      }
    }

    const updatedProductList = products.map((orderItem) =>
      orderItem.design_id === item.design_id
        ? {
            ...orderItem,
            quantity: newQuantity,
            price: newQuantity * orderItem.price || 0,
          }
        : orderItem
    );

    setProducts(updatedProductList);
  };

  const onSave = () => {
    const hasBlankQuantities = products.some(
      (item) =>
        item.quantity === null || item.quantity <= 0 || item.quantity === ""
    );

    if (hasBlankQuantities) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          "Please make sure all quantities are filled and greater than zero.",
      });
    } else {
      Swal.fire({
        title: "Order Saved",
        text: "Your order has been successfully saved.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        fetchOrder();
      });
    }
  };

  // console.log(products);

  const discount =
    parseFloat(order?.tax_price) +
    parseFloat(order?.shipping_fee) +
    parseFloat(order?.total_amount) -
    parseFloat(order?.final_amount);

  // console.log(discount);

  return (
    <div>
      {/* <!-- Order Form Modal --> */}
      <div
        className="modal fade"
        id="orderFormModal"
        tabIndex="-1"
        aria-labelledby="orderFormModalTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="orderFormModalTitle">
                Order Form
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeOrderForm"
              ></button>
            </div>
            <form
              id="OrderForm"
              data-form-label="OrderForm"
              onSubmit={handleSbmit(onSubmitData)}
            >
              <div className="modal-body p-0 px-1">
                <div className="container mt-3">
                  {status === "PENDING" && (
                    <input
                      type="text"
                      className="form-control w-25 mb-2"
                      placeholder="Design ID"
                      {...register("designID")}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleEnterAddProduct(e.target.value);
                        }
                      }}
                    />
                  )}
                  {/* Order Form */}
                  <div className="d-flex ">
                    {/* Product Table */}
                    <div
                      className="table-responsive flex-grow-1 border-right"
                      style={{ height: "400px" }}
                    >
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th>Design ID</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody style={{ msOverflowY: "auto" }}>
                          {products?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{item?.product_name}</td>
                              <td>{item?.design_id}</td>
                              <td>
                                <input
                                  type="number"
                                  min="1"
                                  value={item?.quantity}
                                  onChange={(e) =>
                                    handleUpdateQuantity(item, e.target.value)
                                  }
                                  className="order-input"
                                  disabled={status !== "PENDING"}
                                />
                              </td>
                              <td>
                                ₹
                                {(item?.price * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                              <td>
                                ₹
                                {(item?.total_price * 1)?.toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                              
                              <td>
                                {status === "PENDING" && (
                                  <DeleteButton
                                    name={`Product`}
                                    onDelete={() => handleDelete(item.id)}
                                    hide={true}
                                  />
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex flex-column ms-3">
                      <div className="d-flex">
                        {/* <button
                               className="download-button me-2"
                               onClick={downloadOrderForm}
                               type="button"
                             >
                               Order Form
                             </button>
                             <img
                               src="/assets/images/kidskart/icon/file.png"
                               className="download-file"
                             /> */}
                        <img
                          src="/assets/images/kidskart/icon/printer.png"
                          alt="Print Icon"
                          className="cursor-pointer me-3"
                          onClick={handlePrint}
                          title="Print Order Form"
                        />
                      </div>
                      {status === "PENDING" && (
                        <button
                          className="btn px-2 py-1 fw-bold btn-dark mt-5"
                          // style={{position: "absolute", top: "100px", right: "10px"}}
                          onClick={handleModifyAllQuantities}
                          type="button"
                        >
                          Modify
                        </button>
                      )}
                      {status === "PENDING" && (
                        <button
                          className="btn px-2 py-1 fw-bold btn-danger mt-2"
                          // style={{position: "absolute", top: "100px", right: "10px"}}
                          onClick={() => onSave()}
                          type="button"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {/* {!isLoading2 ? (
                       <button type="submit" className="btn btn-primary col-12">
                         CALCULATE
                       </button>
                     ) : (
                       <div className="col-12">
                         <button
                           type="button"
                           className="btn btn-primary col-12"
                           disabled
                         >
                           CALCULATE
                         </button>
     
                         <div className="spinner-border text-primary" role="status">
                           <span className="visually-hidden">Loading...</span>
                         </div>
                       </div>
                     )} */}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Order Form Modal --> */}

      {/* Download Order Form */}
      <div
        className="modal fade"
        id="orderFormDownload"
        tabIndex="-1"
        aria-labelledby="orderFormDownloadModalTitle"
        aria-hidden="true"
      >
        <div id="orderFormToPrint" className="">
          {/* d-none */}

          <div className="body3">
            <div className="container3">
              <div className="row" ref={orderFormRef}>
                <div className="text-left mb-4">
                  <p className="mb-0">{orderId}</p>
                  <p className="mb-0">
                    {new Date(order?.created_at)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      })
                      .replaceAll(" ", "-")}
                  </p>
                  <p className="fw-bold mb-0">{order?.retailer}</p>
                  <p>{order?.delivery_address}</p>
                </div>

                {/* <!-- Download Order Form --> */}
                <div className="d-flex flex-wrap">
                  {/* <!-- Single Block --> */}
                  {products &&
                    products.length > 0 &&
                    products?.map((item, i) => (
                      <>
                        <div className="mini-box"></div>
                        <div className="custom-col p-1 text-left">
                          <p className="pb-2" style={{ fontSize: "smaller" }}>
                            {item?.brand_name}
                          </p>
                          <div className="d-flex justify-content-between">
                            <p
                              className="fw-bold mb-1"
                              style={{ fontSize: "small" }}
                            >
                              {item?.design_id?.split("-")?.[1]}
                            </p>
                            <p
                              className="fw-bold mb-1"
                              style={{ fontSize: "small" }}
                            >
                              {item?.size}
                            </p>
                          </div>
                          <hr className="my-0" />
                          <p className="text-center mb-0">
                            1@
                            {(item?.price * 1)?.toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </p>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Download Order Form */}

      {/* <!-- Shipping Fee Calculation Modal --> */}
      <div
        className="modal fade"
        id="shippingFeeModal"
        tabIndex="-1"
        aria-labelledby="shippingFeeModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form id="feeCalculationForm" data-form-label="feeCalculation">
              <div className="modal-body">
                <div className="container">
                  {/* ESTIMATED INVOICE to print */}
                  <div id="challanToPrint" className="d-none">
                    <div className="body2">
                      <div className="container2">
                        <h2 className="fw-bold text-center">
                          ESTIMATED INVOICE
                        </h2>
                        <div className="header2">
                          <img
                            src="../../../logo192.png"
                            alt="Logo"
                            className="logo2"
                          />
                          <div className="order-info">
                            <div className="order-details">
                              <div>Order ID: #{orderId}</div>
                              <div>Company Name: {order?.shop_name}</div>
                              <div>
                                {" "}
                                {order?.gst_no ? (
                                  <div>GST Number: {order?.gst_no}</div>
                                ) : order?.pan_no ? (
                                  <div>PAN Number: {order?.pan_no}</div>
                                ) : null}
                              </div>
                              <div>
                                {" "}
                                Date:{" "}
                                {new Date(order?.created_at)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  })
                                  .replaceAll(" ", "-")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <table className="items-table">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Brand Name</th>
                              {/* <th>Description</th> */}
                              <th>Design No.</th>
                              <th>Quantity</th>
                              <th>Rate</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Existing record */}
                            {products &&
                              products?.length > 0 &&
                              products.map((item, i) => (
                                <tr>
                                  <td>{i + 1}</td>
                                  <td>{item.brand_name}</td>
                                  <td>{item.design_id}</td>
                                  <td>{item.quantity}</td>
                                  <td>
                                    ₹
                                    {(item.price * 1)?.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}
                                  </td>
                                  <td>
                                    ₹
                                    {(item?.total_price * 1)?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </td>
                                </tr>
                              ))}

                            {/* Total gross amount */}
                            <tr>
                              <td
                                colSpan="3"
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                  border: "none",
                                }}
                              >
                                Total:
                              </td>
                              <td
                                colSpan="1"
                                style={{ fontWeight: "bold", border: "none" }}
                              >
                                {totalQuantity}
                              </td>
                              <td></td>
                              <td
                                style={{ fontWeight: "bold", border: "none" }}
                              >
                                ₹
                                {(order?.total_amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="footer2">
                        <p>
                          <strong>
                            KidsKart Powered By Bharat Kumar Motilal & Co.
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* TAX INVOICE to print */}
                  <div id="htmlToPrint" className="d-none">
                    <div className="body2">
                      <div className="container2">
                        <h2 className="fw-bold text-center">TAX INVOICE</h2>
                        <div className="header2">
                          <img
                            src="../../../logo192.png"
                            alt="Logo"
                            className="logo2"
                          />
                          <div className="order-info">
                            <div className="order-details">
                              <div>Order ID: #{orderId}</div>
                              {/* <div>Invoice ID: INV-12345678-1a2b3456</div> */}
                              {order?.gst_no ? (
                                <div>GST Number: {order?.gst_no}</div>
                              ) : order?.pan_no ? (
                                <div>PAN Number: {order?.pan_no}</div>
                              ) : null}
                              <div>
                                Date:{" "}
                                {new Date(order?.created_at)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  })
                                  .replaceAll(" ", "-")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="address-container">
                          <div className="address-box">
                            <p>
                              <strong>Billing Address:</strong>
                            </p>
                            <p>{order?.retailer}</p>
                            <p>{order?.billing_address || order?.address}</p>
                          </div>
                          <div className="address-box">
                            <p>
                              <strong>Shipping Address:</strong>
                            </p>
                            <p>{order?.retailer}</p>
                            <p>{order?.delivery_address || order?.address}</p>
                          </div>
                        </div>
                        <table className="items-table">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Brand Name</th>
                              <th>Design ID</th>
                              <th>Size</th>
                              <th>Price</th>
                              <th>Quantity</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {products &&
                              products.length > 0 &&
                              products.map((item, i) => (
                                <tr>
                                  <td>{i + 1}</td>
                                  <td>{item.brand_name}</td>
                                  <td>{item.design_id}</td>
                                  <td>{item.size}</td>
                                  <td>
                                    ₹
                                    {(item.price * 1)?.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}
                                  </td>
                                  <td>{item.quantity} PCS</td>
                                  <td>
                                    ₹
                                    {(item?.total_price * 1)?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="total-info">
                          <table className="total-info-table1">
                            {/* <tr>
                              <th>Total MRP:</th>
                              <td>
                                ₹
                                {(order?.total_amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr> */}
                            {order?.discount_amount > 0 ? (
                              <tr>
                                <th>Discount:</th>
                                <td>
                                  -₹
                                  {(order?.discount_amount * 1)?.toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                              </tr>
                            ) : null}
                            <tr>
                              <th>Tax:</th>
                              <td>
                                ₹
                                {(order?.tax_price * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th>Shipping Fee: (0.5%)</th>
                              <td>
                                ₹
                                {(order?.shipping_fee * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th>Total Amount:</th>
                              <td>
                                ₹
                                {(order?.final_amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div className="additional-info1">
                          <p className="row p-0 m-0">
                            <div className="col-sm-2">
                              <strong>Address:</strong>
                            </div>
                            <div className="col-sm-10">
                              Essgee Options One, 6th Floor, Unit No. 613-615,
                              Kakasaheb Gadgil Marg, Dadar (W), Mumbai - 400025{" "}
                            </div>

                            <div className="col-sm-2">
                              <strong>Email:</strong>
                            </div>
                            <div className="col-sm-10">
                              bmcompany1952@gmail.com
                            </div>
                            <div className="col-sm-2">
                              <strong className="col-sm-2">Phone:</strong>
                            </div>
                            <div className="col-sm-10">
                              022-48257768, 022-48261313
                            </div>
                          </p>
                        </div>
                        <div className="footer2">
                          <p>
                            <strong>
                              KidsKart Powered By Bharat Kumar Motilal & Co.
                            </strong>
                          </p>
                          <p>Thank you for your purchase!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Shipping Fee Calculation Modal --> */}

      <div className="order-details-container row">
        <div className="col-sm-12 col-lg-12 col-xl-12 p-2 mb-2">
          {/* Shipping Details */}
          <div className="shipping-details">
            <div className="row">
              <div className="col-sm-6">
                <h6>Shipping Address: {order?.retailer}</h6>
                <p>{order?.delivery_address || order?.address}</p>
              </div>
              <div className="col-sm-6">
                <h6>Billing Address: {order?.retailer}</h6>
                <p>{order?.billing_address || order?.address}</p>
              </div>
            </div>

            <div className="row">
              <p className="col-sm-3">
                <strong>Order Number:</strong> {order?.order_id}
              </p>

              <p className="col-sm-3">
                <strong>Date:</strong>{" "}
                {new Date(order?.created_at)
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })
                  .replace(" ", " ")
                  .replace(/(\w+ \w+)/, "$1,")}
              </p>

              <p className="col-sm-3">
                <strong>Order Status: </strong>
                <button
                  className={`btn ${buttonClass} light btn-sm order-status`}
                  type="button"
                >
                  {status}
                </button>
              </p>
              <p className="col-sm-3">
                <button
                  className={`btn btn-warning btn-md order-status`}
                  data-bs-toggle="modal"
                  data-bs-target="#orderFormModal"
                  type="button"
                >
                  Generate Order Form
                </button>
              </p>
            </div>
            <div className="row">
              {["CONFIRMED", "SHIPPED", "DELIVERED", "CANCELLED"].includes(
                status
              ) &&
                !(status === "CANCELLED" && order?.paid_amount === null) && (
                  <p className="col-sm-3">
                    <button
                      type="button"
                      className="download-button me-2"
                      onClick={downloadchallanPDF}
                    >
                      Estimated Invoice
                    </button>
                    <img
                      src="/assets/images/kidskart/icon/file.png"
                      className="download-file"
                    />
                  </p>
                )}

              {["CONFIRMED", "SHIPPED", "DELIVERED", "CANCELLED"].includes(
                status
              ) &&
                !(status === "CANCELLED" && order?.paid_amount === null) && (
                  <p className="col-sm-3">
                    <button
                      className="download-button me-2"
                      onClick={downloadPDF}
                      type="button"
                    >
                      Tax Invoice
                    </button>
                    <img
                      src="/assets/images/kidskart/icon/file.png"
                      className="download-file"
                    />
                  </p>
                )}
            </div>
          </div>
        </div>

        <div className="col-sm-7 col-lg-7 col-xl-7 p-2">
          {/* Order Summary */}
          <div className="order-summary">
            <div className="order-header ms-2">
              <h4>Products</h4>
            </div>
            <div
              className="order-items-scroll"
              style={{
                maxHeight: "413px",
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              {products &&
                products.length > 0 &&
                products?.map((item, i) => (
                  <div className="order-item" key={i}>
                    <div className="item-details">
                      <div className="d-flex justify-content-between">
                        <h6>
                          {i + 1}. {item?.product_name} - {item?.brand_name}{" "}
                        </h6>{" "}
                        <div className="item-total">{item?.design_id}</div>
                      </div>

                      <div className="row">
                        <p className="col-sm-4 mb-1">Size: {item?.size}</p>
                        <p className="col-sm-4 mb-1">
                          Pieces Qty: {item?.quantity}
                        </p>
                        <p className="col-sm-4 mb-1">
                          Price: ₹
                          {(item?.price * 1)?.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                      <p className="item-total mb-0">
                        Total Price: ₹
                        {(item?.total_price * 1)?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="col-sm-5 col-lg-5 col-xl-5 p-2 mb-2">
          {/* Pricing Details */}
          <div className="pricing-summary">
            {/* Sub Total */}
            <p>
              Sub Total:{" "}
              <span>
                ₹
                {(order?.total_amount * 1)?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>

            {/* Item Discount */}
            {/* {discount > 0 ? <p>
              Discount:{" "}
              <span>
                -₹
                { discount > 0 ? (discount * 1).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }): 0}
              </span>
            </p> : null} */}

            {order?.discount_amount > 0 && (
              <p>
                Discount:{" "}
                <span>
                  -₹
                  {(order?.discount_amount * 1)?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
            )}

            {/* Total Tax */}
            <p>
              Total Tax:{" "}
              <span>
                ₹
                {(order?.tax_price * 1)?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>

            {/* Shipping Fee */}
            <p>
              Shipping Fee: (0.5%){" "}
              <span>
                {order?.shipping_fee === 0
                  ? "Free"
                  : `₹${(order?.shipping_fee * 1)?.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
              </span>
            </p>

            <hr />

            {/* Total Amount */}
            <p className="order-total">
              Total Amount:{" "}
              <span>
                ₹
                {(order?.final_amount * 1)?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>
            <hr />

            <p className="order-total">
              Payment Status:
              <div>
                {order?.remaining_amount === 0 ? (
                  <span className="text-success fs-6 fw-bold">Paid</span>
                ) : (
                  <button
                    className="pay-button btn pay-btn"
                    type="button"
                    onClick={() => handleTabChange("payment")}
                  >
                    Track Payment
                  </button>
                )}
              </div>
            </p>
            <hr />

            <div
              className="d-flex justify-content-between align-items-center mt-3"
              style={{ fontSize: "1rem" }}
            >
              {/*  Commission */}
              <div>
                <strong>Agent Commission (3%):</strong>{" "}
                <span>
                  ₹
                  {(order?.agent_commision * 1)?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
                <br />
                <small>(Based on Sub Total - Discount)</small>
              </div>

              {/*  Payment Status/Action */}
              <div>
                {order?.paymentStatus === "Paid" ? (
                  <span className="text-success fs-6 fw-bold">Paid</span>
                ) : (
                  <button
                    className="pay-button btn btn-primary"
                    type="button"
                    onClick={() => handleTabChange("commision")}
                  >
                    Track Commission
                  </button>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="action-buttons mt-5 text-center">
              {renderButtons()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
